import React, { FC } from "react"
import { Contents } from "./Contents"
import { ITwoColumnBulletList } from "contentful-types"
import { DynamicContentComponentProps } from "./DynamicContentComponentProps"
import { Box } from "@carrotfertility/carotene-core"

/**
 * Comments were preserved during a tiny mobile responsive-ness fix for when this code eventually gets a proper refactor.
 * We should refactor this when we convert all components to carotene-core. This currently doesn't follow best practices
 */

const TwoColumnBulletList: FC<DynamicContentComponentProps<ITwoColumnBulletList>> = ({ content }) => {
  const {
    fields: { content: internalContent }
  } = content
  return (
    <Box
      component="ul"
      sx={{
        marginTop: "16px", // This should really be margin-bottom on the heading, but we didn't want to touch that code at this time
        display: "flex",
        flexWrap: "wrap",
        gap: "16px", // Not sure if this is the best solution for adding space between items
        li: {
          display: "inline-block",
          width: { sm: "100%", md: "calc(50% - 24px)" }, // 24px = 8px for gap, 16px for negative margin to bring in List orange dot
          marginLeft: "16px",
          "&>div": {
            display: " inline-block", // adjusting so that list circle lines up with li text
            marginTop: "-0.2rem",
            verticalAlign: " text-top",
            "&>p": {
              fontSize: "14px",
              margin: 0
            }
          }
        }
      }}
    >
      <Contents contents={internalContent} asList />
    </Box>
  )
}

export { TwoColumnBulletList }
